import type { Utility } from '../../../types/utility';

const base: Utility.CSSProperties = {
  borderTopColor: 'coolGrey.30',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  '&:first-of-type': {
    borderColor: 'coolGrey.30',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
  },
  '&:last-of-type': {
    borderColor: 'coolGrey.30',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
  },
};

const chart = {
  default: {
    ...base,
    backgroundColor: 'indigo.100',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const co = {
  default: {
    ...base,
    backgroundColor: 'indigo.100',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const edu = {
  default: {
    ...base,
    backgroundColor: 'indigo.100',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const scale = {
  default: {
    ...base,
    backgroundColor: 'indigo.90',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const spark = {
  default: {
    ...base,
    backgroundColor: 'indigo.90',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const item: Utility.VariantKeyModes<ItemVariantsType> = {
  products: {
    chart,
    chartblog: chart,
    co,
    edu,
    scale,
    spark,
  },
};

export type ItemVariantsType = 'default' | 'inverse' | 'transparent';
export const itemVariants = Object.keys(chart) as ItemVariantsType[];

export default item;
